<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="pt1" epub:type="part" role="doc-part">
<header>
<h1 class="PT" id="pt1"><span aria-label="11" id="pg_11" role="doc-pagebreak"><samp class="SANS_Avenir_Light_229">ZERO WASTE</samp> <samp class="SANS_Avenir_Black_B_229">MAKES</samp></span></h1>
</header>
<p class="opener-intro"><samp class="SANS_Milliard_Thin_229">From cleaning cloths to ingenious storage, find a project that appeals to you from the following collection and start your journey to zero waste.</samp></p>
<figure class="IMG-NOBOT"><span aria-label="10" id="pg_10" role="doc-pagebreak"><img alt="" class="img100" src="images/pg10.jpg"/>
</span></figure>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?38a1f25c